module.exports = __webpack_public_path__ + "img/android-arrow-forward.1c6d07ad.svg";